import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { Grid, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import { PAGES } from '../../constants/configuration';

function areEqual(_prevProps: any, _nextProps: any) {
    /*
  return true if passing nextProps to render would return
  the same result as passing prevProps to render,
  otherwise return false
  */
    return true;
}

const Item = styled(Paper)(({ theme }: any) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

function Home() {
    const history = useHistory();

    useEffect(() => {
        history.push(PAGES.CALENDAR);
    }, []);
    return (
        <div>
            <Box style={{ flexGrow: 1, padding: 10, overflowX: 'hidden' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Item></Item>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
}

export default React.memo(Home, areEqual);
